import { Button, Modal } from '../ui'

export const AlertDeleteCategories = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Eliminar Categoría"
      size="sm"
    >
      <p>¿Estás seguro? No podrás deshacer esta acción después.</p>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0.5rem',
          marginTop: '1.5rem',
        }}
      >
        <Button variant="ghost" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Eliminar
        </Button>
      </div>
    </Modal>
  )
}
